import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { AUTH_API_CONFIGURATION, AuthApiConfiguration } from '../config/auth-api-configuration';

@Injectable()
export class AuthApiService {
  protected uri = '/api/v2';

  constructor(private http: HttpClient, @Inject(AUTH_API_CONFIGURATION) private config: AuthApiConfiguration) {}

  confirmSignUp(data): Observable<any> {
    return this.http.post(this.config.apiUrl + this.uri + '/auth/cognito/register/confirm', data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  checkUserExistByToken(data): Observable<any> {
    return this.http.post(this.config.apiUrl + this.uri + '/auth/cognito/exists', data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  changePassword(data): Observable<any> {
    return this.http.post(this.config.apiUrl + this.uri + '/auth/change-password', data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  changePasswordAsAdmin(data): Observable<any> {
    return this.http.post(this.config.apiUrl + this.uri + '/auth/admin/change-password', data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  cognitoUpdateEmail(data): Observable<any> {
    return this.http.put(this.config.apiUrl + this.uri + '/auth/cognito/email', data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  updateProfile(data, headers?: HttpHeaders): Observable<any> {
    return this.http.put(this.config.apiUrl + this.uri +'/me/profile', data, {
      headers
    }).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  getProfile(headers?: HttpHeaders): Observable<any> {
    return this.http.get(this.config.apiUrl + this.uri + '/me/profile', {
      params: { includes: 'roles' },
      headers
    }).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }


  cognitoVerifyUpdateEmail(data): Observable<any> {
    return this.http.put(this.config.apiUrl + this.uri + `/user/cognito/email`, data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }
}
